import { ComponentStyleConfig } from "@chakra-ui/react";

export const Heading: ComponentStyleConfig = {
    baseStyle: {
        fontWeight: "semibold",
    },
};
